<template>
    <LegendItem description="Weekend of feestdag">
        <PlanbordCell
            :day="{...rosterDay, weekend: true}"
            :dayIndex="1"
            :resourceIndex="1000"
            :roster="roster"
            :rosterNames="rosterNames"
            :resource="resource"
            :leavePeriods="[]"
            :shifts="legendShifts"
            :organisationDeploymentStates="deploymentStates"
            :hasLeaveForm="false"
            :permissions="userPermissions"
            :clipboard="[]"
        />
    </LegendItem>
    <LegendItem description="Werkdag">
        <PlanbordCell
            :day="rosterDay"
            :dayIndex="1"
            :resourceIndex="1000"
            :roster="roster"
            :rosterNames="rosterNames"
            :resource="resource"
            :leavePeriods="[]"
            :shifts="legendShifts"
            :organisationDeploymentStates="deploymentStates"
            :hasLeaveForm="false"
            :permissions="userPermissions"
            :clipboard="[]"
        />
    </LegendItem>
    <LegendItem description="Verlof" v-if="hasDeploymentState(deploymentStateEnum.Free)">
        <PlanbordCell
            :day="rosterDay"
            :dayIndex="1"
            :resourceIndex="1000"
            :roster="roster"
            :rosterNames="rosterNames"
            :resource="resource"
            :leavePeriods="[]"
            :shifts="legendShifts"
            :organisationDeploymentStates="deploymentStates"
            :hasLeaveForm="true"
            :permissions="userPermissions"
            :clipboard="[]"
        />
    </LegendItem>
    <LegendItem description="Ziek" v-if="hasDeploymentState(deploymentStateEnum.Sick)">
        <PlanbordCell
            :day="rosterDay"
            :dayIndex="1"
            :resourceIndex="1000"
            :roster="roster"
            :rosterNames="rosterNames"
            :resource="resourceInSickPeriod"
            :leavePeriods="[]"
            :shifts="legendShifts"
            :organisationDeploymentStates="deploymentStates"
            :hasLeaveForm="false"
            :permissions="userPermissions"
            :clipboard="[]"
        />
    </LegendItem>
    <LegendItem description="Gedeeltelijk Ziek" v-if="hasDeploymentState(deploymentStateEnum.Sick)">
        <PlanbordCell
            :day="rosterDay"
            :dayIndex="1"
            :resourceIndex="1000"
            :roster="roster"
            :rosterNames="rosterNames"
            :resource="resourceInSickPeriodPartlySick"
            :leavePeriods="[]"
            :shifts="legendShifts"
            :organisationDeploymentStates="deploymentStates"
            :hasLeaveForm="false"
            :permissions="userPermissions"
            :clipboard="[]"
        />
    </LegendItem>
    <LegendItem description="Einde gepubliceerd">
        <PlanbordCell
            :day="{...rosterDay, proposed:true}"
            :dayIndex="1"
            :resourceIndex="1000"
            :roster="rosterPublishedEnd"
            :rosterNames="rosterNames"
            :resource="resource"
            :leavePeriods="[]"
            :shifts="legendShifts"
            :organisationDeploymentStates="deploymentStates"
            :hasLeaveForm="false"
            :permissions="userPermissions"
            :clipboard="[]"
        />
    </LegendItem>
    <LegendItem description="Stempel (in voorgesteld of gepubliceerd rooster)">
        <PlanbordCell
            :day="{...rosterDay, proposed: true}"
            :dayIndex="1"
            :resourceIndex="1000"
            :roster="rosterProposedUntilStartDate"
            :rosterNames="rosterNames"
            :resource="resourceInStampPeriod"
            :leavePeriods="[]"
            :shifts="legendShifts"
            :organisationDeploymentStates="deploymentStates"
            :hasLeaveForm="false"
            :permissions="userPermissions"
            :clipboard="[]"
        />
    </LegendItem>
    <LegendItem description="Stempel (in rooster in stempelfase)">
        <PlanbordCell
            :day="rosterDay"
            :dayIndex="1"
            :resourceIndex="1000"
            :roster="rosterProposedUntilStartDate"
            :rosterNames="rosterNames"
            :resource="resource"
            :leavePeriods="[]"
            :shifts="legendShifts"
            :organisationDeploymentStates="deploymentStates"
            :hasLeaveForm="false"
            :permissions="userPermissions"
            :stamp="stamp"
            :clipboard="[]"
        />
    </LegendItem>
    <LegendItem description="Verlof in stempelfase" v-if="hasDeploymentState(deploymentStateEnum.Free)">
        <PlanbordCell
            :day="rosterDay"
            :dayIndex="1"
            :resourceIndex="1000"
            :roster="rosterProposedUntilStartDate"
            :rosterNames="rosterNames"
            :resource="resource"
            :leavePeriods="[]"
            :shifts="legendShifts"
            :organisationDeploymentStates="deploymentStates"
            :hasLeaveForm="true"
            :permissions="userPermissions"
            :stamp="stamp"
            :clipboard="[]"
        />
    </LegendItem>
    <LegendItem description="Ziek in stempelfase" v-if="hasDeploymentState(deploymentStateEnum.Sick)">
        <PlanbordCell
            :day="rosterDay"
            :dayIndex="1"
            :resourceIndex="1000"
            :roster="rosterProposedUntilStartDate"
            :rosterNames="rosterNames"
            :resource="resourceInSickPeriod"
            :leavePeriods="[]"
            :shifts="legendShifts"
            :organisationDeploymentStates="deploymentStates"
            :hasLeaveForm="false"
            :permissions="userPermissions"
            :stamp="stamp"
            :clipboard="[]"
        />
    </LegendItem>
    <LegendItem description="Wens">
        <PlanbordCell
            :day="rosterDay"
            :dayIndex="1"
            :resourceIndex="1000"
            :roster="roster"
            :rosterNames="rosterNames"
            :resource="resource"
            :leavePeriods="[]"
            :shifts="legendShifts"
            :organisationDeploymentStates="deploymentStates"
            :hasLeaveForm="false"
            :permissions="userPermissions"
            :clipboard="[]"
            :wish="wish"
        />
    </LegendItem>
    <LegendItem description="Medewerker niet (meer) in dienst">
        <PlanbordCell
            :day="rosterDay"
            :dayIndex="1"
            :resourceIndex="1000"
            :roster="rosterProposedUntilStartDate"
            :rosterNames="rosterNames"
            :resource="resourceAfterEndDate"
            :leavePeriods="[]"
            :shifts="legendShifts"
            :organisationDeploymentStates="deploymentStates"
            :hasLeaveForm="false"
            :permissions="userPermissions"
            :clipboard="[]"
        />
    </LegendItem>
</template>

<script lang="ts">
    import {Globals, Shift, PersonalStamp, PersonalPlanningWish, OrganisationDeploymentState, RosterRankSet, DeploymentState, DeploymentStateNumber, ShiftTypeNumber, ShiftTemplateColor} from '@cquential/api';
    import {ResourceWithKeyedByDateObjects} from '@/types/api-object-extensions';
    import {RosterDay, PermissionsForRoster, RosterData} from '@/types/types';
    import PlanbordCell from '@/components/Planbord/PlanbordCell.vue';
    import Dates from '@cquential/date-utils';
    import LegendItem from '@/components/modals/Legend/LegendItem.vue';
    import {DEFAULT_BEGIN_DATE, DEFAULT_END_DATE} from '@/util/Defaults';
    import {Component, Vue, Prop} from 'vue-facing-decorator';

    @Component({
        components: {
            PlanbordCell,
            LegendItem,
        },
    })
    export default class CellLegendItems extends Vue {
        @Prop({required: true}) public globals!: Globals;
        @Prop({required: true}) public deploymentStates!: Record<number, OrganisationDeploymentState>;
        @Prop({required: true}) public rosterNames!: Record<number, string>;
        @Prop({required: true}) public permissions!: PermissionsForRoster;

        private get startDate(): Date {
            return Dates.Utils.startOfWeek(Dates.Utils.today());
        }

        private get rosterDay(): RosterDay {
            return {
                ended: false,
                published: false,
                proposed: false,
                holiday: false,
                dayName: 'Maandag',
                dayAbbreviation: 'ma',
                formattedDateOnly: 'ma 02-01',
                formattedForComputers: '2023-02-01',
                formattedDateIso: '2023-02-01T00:00:00.000Z',
                weekend: false,
                date: this.startDate,
            };
        }

        private get rosterRankSet(): RosterRankSet {
            return {
                rosterId: 1,
                beginDate: new Date(DEFAULT_BEGIN_DATE),
                endDate: new Date(DEFAULT_END_DATE),
                titles: [],
                resourceRosterRanks: [],
            };
        }

        private get roster(): RosterData {
            return {
                rosterResources: [],
                resourcesFromOtherRosters: [],
                externalResources: [],
                relatedResources: [],
                beginDate: Dates.Utils.addDays(this.startDate, -90),
                endDate: Dates.Utils.addDays(this.startDate, 10),
                deriveRightsUntil: this.startDate,
                publishedUntil: this.startDate,
                proposedUntil: Dates.Utils.addDays(this.startDate, 7),
                days: [],
                rosterId: 1,
                rosterRankSet: this.rosterRankSet,
                companies: {},
                organisationId: 'Organisatie',
                timeTypes: {},
                holidays: [],
                unpublishedPartVisibleUntil: null,
                wishInputClosedUntil: null,
                wishInputEnabled: false,
                openShifts: {},
                usesMarketplaceFunctions: false,
            };
        }

        private get rosterProposedUntilStartDate(): RosterData {
            return {
                ...this.roster,
                proposedUntil: this.startDate,
            };
        }

        private get rosterPublishedEnd(): RosterData {
            return {
                ...this.roster,
                deriveRightsUntil: Dates.Utils.addDays(this.startDate, -1),
                publishedUntil: Dates.Utils.addDays(this.startDate, -1),
            };
        }

        private get resource(): ResourceWithKeyedByDateObjects {
            return {
                id: 1,
                employmentId: 1,
                name: 'Resource',
                nameAddendum: null,
                beginDate: Dates.Utils.addDays(this.startDate, -28),
                endDate: Dates.Utils.addDays(this.startDate, 10),
                workingHoursActType: 'Standaard',
                stampDeployedUntil: Dates.Utils.addDays(this.startDate, 4),
                salaryAcceptedUntil: this.startDate,
                contractedTimes: [],
                leavePeriods: [],
                leavePeriodsFromForms: [],
                personalStamps: [{
                    id: 1,
                    resourceId: 1,
                    beginDate: Dates.Utils.addDays(this.startDate, -28),
                    endDate: null,
                    iterationLength: 14,
                }],
                sickPeriods: [],
                deployments: {},
                deploymentProposals: {},
                assignedDays: {},
                unavailabilities: {},
            };
        }

        private get resourceInStampPeriod(): ResourceWithKeyedByDateObjects {
            return {
                ...this.resource,
                stampDeployedUntil: Dates.Utils.addDays(this.startDate, -2),
            };
        }

        private get resourceInSickPeriod(): ResourceWithKeyedByDateObjects {
            return {
                ...this.resource,
                sickPeriods: [
                    {
                        beginDate: this.startDate,
                        creationDate: this.startDate,
                        expectedRecoveryDate: this.startDate,
                        endDate: Dates.Utils.addDays(this.startDate, 4),
                        resourceId: 1,
                        percentages: [
                            {
                                beginDate: this.startDate,
                                creationDate: this.startDate,
                                id: 1,
                                percentage: 100,
                                sickPeriodId: 1,
                            },
                        ],
                    },
                ],
            };
        }

        private get legendShifts(): Record<number, Shift> {
            return {
                1: {
                    id: 1,
                    rosterId: 1,
                    beginDate: Dates.Utils.addDays(this.startDate, -100),
                    endDate: Dates.Utils.addDays(this.startDate, 100),
                    templateId: 1,
                    template: {
                        id: 1,
                        typeNumber: ShiftTypeNumber.Paraat,
                        type: 'Paraat',
                        isLongPresence: false,
                        code: 'D8',
                        colorId: ShiftTemplateColor.Day,
                        legend: 'Dag 8:30-17:00',
                        isDefault: true,
                        andParentTemplateId: null,
                        orParentTemplateId: null,
                        specifications: [{begin: '08:30', end: '17:00', typeId: 2}],
                        hasAllStates: true,
                        hasLeaveState: true,
                    },
                    postalCode: null,
                    houseNumber: null,
                },
            };
        }

        private get resourceInSickPeriodPartlySick(): ResourceWithKeyedByDateObjects {
            return {
                ...this.resource,
                sickPeriods: [
                    {
                        beginDate: this.startDate,
                        creationDate: this.startDate,
                        expectedRecoveryDate: this.startDate,
                        endDate: Dates.Utils.addDays(this.startDate, 4),
                        resourceId: 1,
                        percentages: [
                            {
                                beginDate: this.startDate,
                                creationDate: this.startDate,
                                id: 1,
                                percentage: 50,
                                sickPeriodId: 1,
                            },
                        ],
                    },
                ],
                deployments: {
                    [this.rosterDay.formattedDateIso]: [
                        {
                            date: this.startDate,
                            shiftId: 1,
                            stateId: DeploymentStateNumber.Normal,
                            resourceId: 1,
                            companyId: null,
                            companyEmployeeId: null,
                            publicComment: null,
                        },
                        {
                            date: this.startDate,
                            shiftId: 1,
                            stateId: DeploymentStateNumber.Sick,
                            resourceId: 1,
                            companyId: null,
                            companyEmployeeId: null,
                            publicComment: null,
                        },
                    ],
                },
            };
        }

        private get resourceAfterEndDate(): ResourceWithKeyedByDateObjects {
            return {
                ...this.resource,
                endDate: Dates.Utils.addDays(this.startDate, -1),
            };
        }

        private get stamp(): PersonalStamp {
            return {
                resourceId: 1,
                beginDate: Dates.Utils.addDays(this.startDate, -365),
                endDate: Dates.Utils.addDays(this.startDate, 365),
                iterationLength: 14,
                personalStampShifts: [],
            };
        }

        private get userPermissions(): Record<number, PermissionsForRoster> {
            return {1: this.permissions};
        }

        private get wish(): PersonalPlanningWish {
            return {
                doesntWantToWorkBegin: null,
                doesntWantToWorkEnd: null,
                date: this.startDate,
                recursWeekly: false,
                recursOnDay: 1,
                description: 'wens',
                resourceId: 1,
                wantsShiftId1: null,
                wantsShiftId2: null,
                wantsShiftId3: null,
            };
        }

        public get deploymentStateEnum(): typeof DeploymentState {
            return DeploymentState;
        }

        public hasDeploymentState(id: DeploymentState): boolean {
            return Object.values(this.deploymentStates).some((o: OrganisationDeploymentState): boolean => o.id === id);
        }
    }
</script>
